import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'

const state = {
  menu: [],
  classes: [],
  title: '',
  header: true,
  footer: true,
  logoPreview: '',
}

export const actionTypes = {
  MENU: 'MENU',
  TITLE: 'TITLE',
  CLASSES: 'CLASSES',
  HEADER: 'HEADER',
  FOOTER: 'FOOTER',
  LOGO_PREVIEW: 'LOGO_PREVIEW',
}

// REDUCERS
export const reducer = (state = state, action) => {
  switch (action.type) {
  case actionTypes.TITLE:
    return Object.assign({}, state, { title: action.title })
  case actionTypes.MENU:
    return Object.assign({}, state, { menu: action.menu })
  case actionTypes.CLASSES:
    return Object.assign({}, state, { classes: action.classes })
  case actionTypes.HEADER:
    return Object.assign({}, state, { header: action.header })
  case actionTypes.FOOTER:
    return Object.assign({}, state, { footer: action.footer })
  case actionTypes.LOGO_PREVIEW:
    return Object.assign({}, state, { logoPreview: action.logoPreview })
  default: return state
  }
}

// ACTIONS
export const setTitle = (title) => dispatch => {
  return dispatch({ type: actionTypes.TITLE, title: title })
}

export const activeMenu = (menu) => dispatch => {
  return dispatch({ type: actionTypes.MENU, menu: menu })
}

export const setClass = (classes) => dispatch => {
  return dispatch({ type: actionTypes.CLASSES, classes: classes })
}

export const showHeader = (header) => dispatch => {
  return dispatch({ type: actionTypes.HEADER, header: header })
}

export const showFooter = (footer) => dispatch => {
  return dispatch({ type: actionTypes.FOOTER, footer: footer })
}

export const setLogo = logoPreview => dispatch => {
  return dispatch({ type: actionTypes.LOGO_PREVIEW, logoPreview })
}

export function initializeStore (initialState = state) {
  return createStore(reducer, initialState, composeWithDevTools(applyMiddleware(thunkMiddleware)))
}